import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ExpressComponent } from './express.component';
import { ExpressListComponent } from './express-list/express-list.component';
import { ExpressRequestComponent } from './express-request/express-request.component';
import { ExpressDetailsComponent } from './express-details/express-details.component';

const routes: Routes = [{
  path:'',
  component:ExpressComponent,
  children:[
    {path:'',component:ExpressListComponent},
    {path:'request',component:ExpressRequestComponent},
    {path:'request/:uuid',component:ExpressRequestComponent},
    {path:'details/:uuid',component:ExpressDetailsComponent},
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ExpressRoutingModule { }
